import React, { FC } from "react";
import { Platform, View, ViewProps, ViewStyle } from "react-native";

import { useAppTheme } from "@/hooks/useAppTheme";
import { THEME_VARS } from "@/theme/theme";

type VnBoxPropsType = ViewProps & {
  shouldHideScrollIndicator?: boolean;
};

const HIDE_SCROLLBAR_STYLE =
  Platform.OS === "web" ? ({ scrollbarWidth: "none" } as ViewStyle) : undefined;

export const VnBox: FC<VnBoxPropsType> = ({
  shouldHideScrollIndicator,
  style,
  ...props
}) => {
  return (
    <View
      style={shouldHideScrollIndicator ? [HIDE_SCROLLBAR_STYLE, style] : style}
      {...props}
    />
  );
};

export const VnThemedBox: FC<ViewProps> = props => {
  const { resolvedTheme } = useAppTheme();

  return <VnBox style={THEME_VARS[resolvedTheme]} {...props} />;
};
